import { IProject } from 'redux-store/api/projects';
import { calculateBusinessDays } from 'utils/postDateHelper';

export const projectByIdMapping = (response: IProject): IProject => {
  if (!response) {
    return;
  }

  const scheduleItems = response?.phases.flatMap(({ items }) => items);

  const updatedPhases = response?.phases.map((phase) => ({
    ...phase,
    items: phase.items.map((item) => ({
      ...item,
      linkedItems: item.linkedItems
        .map((linkedItem) => {
          const targetItem = scheduleItems?.find(({ id }) => id === linkedItem?.itemId);
          const sourceItem = scheduleItems?.find(({ id }) => id === linkedItem?.predecessorId);

          if (!targetItem || !sourceItem) {
            return null;
          }

          const isEndAfterOrEqual = sourceItem.endDate >= targetItem.startDate;

          const rawDiff = isEndAfterOrEqual
            ? calculateBusinessDays(
                sourceItem.startDate,
                targetItem.startDate,
                response.workingDays
              ) - 1
            : calculateBusinessDays(
                sourceItem.endDate,
                targetItem.startDate,
                response.workingDays
              ) - 2;

          const diff = isEndAfterOrEqual ? rawDiff - sourceItem.workDays : rawDiff;

          return {
            ...linkedItem,
            workDaysDifference: diff,
          };
        })
        .filter((linkedItem) => !!linkedItem),
      predecessors: item.predecessors
        .map((predecessor) => {
          const targetItem = scheduleItems?.find(({ id }) => id === predecessor?.itemId);
          const sourceItem = scheduleItems?.find(({ id }) => id === predecessor?.predecessorId);

          if (!targetItem || !sourceItem) {
            return null;
          }

          const isEndAfterOrEqual = sourceItem.endDate >= targetItem.startDate;

          const rawDiff = isEndAfterOrEqual
            ? calculateBusinessDays(
                sourceItem.startDate,
                targetItem.startDate,
                response.workingDays
              ) - 1
            : calculateBusinessDays(
                sourceItem.endDate,
                targetItem.startDate,
                response.workingDays
              ) - 2;

          const diff = isEndAfterOrEqual ? rawDiff - sourceItem.workDays : rawDiff;

          return {
            ...predecessor,
            workDaysDifference: diff,
          };
        })
        .filter((predecessor) => !!predecessor),
    })),
  }));

  response.phases = updatedPhases;

  return response;
};
